import { Checkbox, FormControlLabel, Typography } from '@mui/material';

import { translate } from '@/ui/i18n';

export function IncludePublicAnswersForCo2Checkbox({
  value,
  onChange,
}: {
  value: boolean;
  onChange: (checked: boolean) => void;
}) {
  return (
    <FormControlLabel
      sx={{ marginTop: 2 }}
      label={
        <Typography>
          {translate('Quiz.integrate-public-in-co2-calculation')}
        </Typography>
      }
      control={
        <Checkbox
          checked={value}
          onChange={(_, checked: boolean) => onChange(checked)}
        />
      }
    />
  );
}
